import React from 'react';
import { CollectionFilterItemProps } from '../../../models/CollectionFilter';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { FilterAccordion } from '../../styled/StyledAccordion';

export const CollectionFilterItem: React.FC<CollectionFilterItemProps> = (
    props
) => {
    const { item, handleFilter, preSetItems } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilter({
            name: item.name + '|' + event.target.name,
            checked: event.target.checked,
        });
    };

    return (
        <>
            <div>
                <FilterAccordion title={item.name}>
                    <FormGroup>
                        {item.options.map((elem) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        defaultChecked={
                                            preSetItems &&
                                            preSetItems.indexOf(
                                                item.name + '|' + elem.name
                                            ) > -1
                                        }
                                    />
                                }
                                name={elem.name}
                                label={elem.name + ' (' + elem.count + ')'}
                                key={elem.name}
                                onChange={handleChange}
                                disabled={elem.count == 0}
                            />
                        ))}
                    </FormGroup>
                </FilterAccordion>
            </div>
        </>
    );
};
